// Globals
import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';

// Components
import { PenIcon, TrashIcon } from '@/icons';
import { Button, Input } from '@/ui';
import { StyledAnswer, StyledButtons, StyledDate, StyledQuestion, StyledSearchWrapper } from '../components';

// Helpers
import { DateFormats } from '@/constants/dates';
import { renderDate } from '@/utils';
import { IFaqBase } from '@/models/faqBase.model';
import { TFaqSearchFilters } from '../hooks';

type TGetFaqColumnsParams<T extends IFaqBase> = {
  t: TFunction;
  filters?: TFaqSearchFilters;
  onFilterChange?: (field: keyof TFaqSearchFilters, value: string) => void;
  onEdit?: (record: T) => void;
  onDelete?: (record: T) => void;
};

export const getFaqColumns = <T extends IFaqBase>({
  t,
  filters,
  onFilterChange,
  onEdit,
  onDelete,
}: TGetFaqColumnsParams<T>): TableColumnsType<T> => [
  {
    title: t('label_created_at'),
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 120,
    render: (createdAt: string) => <StyledDate>{renderDate(createdAt, DateFormats.DATE_WITH_TIME)}</StyledDate>,
  },
  {
    title: (
      <StyledSearchWrapper>
        <span>{t('label_question_one')}</span>
        <Input
          value={filters?.question ?? ''}
          onChange={(event) => onFilterChange?.('question', event.target.value)}
          size="small"
          placeholder={t('placeholder_search_question')}
        />
      </StyledSearchWrapper>
    ),
    dataIndex: 'question',
    key: 'question',
    width: 220,
    render: (question: string) => <StyledQuestion dangerouslySetInnerHTML={{ __html: question }} />,
  },
  {
    title: (
      <StyledSearchWrapper>
        <span>{t('label_answer_one')}</span>
        <Input
          value={filters?.answer ?? ''}
          onChange={(event) => onFilterChange?.('answer', event.target.value)}
          size="small"
          placeholder={t('placeholder_search_answer')}
        />
      </StyledSearchWrapper>
    ),
    dataIndex: 'answer',
    key: 'answer',
    width: 220,
    render: (answer: string) => <StyledAnswer>{answer}</StyledAnswer>,
  },
  {
    title: t('column_action'),
    key: 'action',
    width: 80,
    render: (_, record) => (
      <StyledButtons>
        <Button icon={<PenIcon />} type="primary" size="small" block onClick={() => onEdit?.(record)} />
        <Button type="primary" size="small" icon={<TrashIcon />} danger block onClick={() => onDelete?.(record)} />
      </StyledButtons>
    ),
  },
];
